import React from 'react';
import {
    EventName,
    EventInfo,
    EventWrapper,
} from 'src/domains/layouts/webview/components/heroEvents/HomepageHeroWidget.style';
import { HeroWidgetImagesType } from 'src/domains/layouts/webview/components/heroEvents/HeroWidgetItem.state';
import { Wrapper } from './HeroWidgetMainBanner.style';
import { ViewAllButton } from 'src/domains/layouts/webview/components/heroEvents/HeroWidgetMainBanner/ViewAllButton';
import { useAppStateContext } from 'src/appState/AppState';

interface HeroWidgetMainBannerPropsType {
    images: HeroWidgetImagesType;
    title: string;
    subtitle?: string | null;
    bgColor?: null | undefined | string;
    onClick: () => void;
}
export const HeroWidgetMainBanner = ({
    images,
    title,
    subtitle,
    bgColor,
    onClick,
}: HeroWidgetMainBannerPropsType): JSX.Element => {
    const {
        unifiedSportEventsTable,
        componentVariants: { sportsbookVariant },
    } = useAppStateContext().unifiedComponentConfig;
    return (
        <Wrapper
            banners={images}
            bgColor={bgColor}
            data-test='widget-banner'
            variant={sportsbookVariant}
        >
            <EventWrapper variant={sportsbookVariant}>
                <EventName data-test='hero-widget-title'>{title}</EventName>
                <EventInfo data-test='hero-widget-subtitle'>{subtitle}</EventInfo>
            </EventWrapper>
            {unifiedSportEventsTable ? <ViewAllButton onClick={onClick} /> : null}
        </Wrapper>
    );
};
